import { useEffect, useState } from 'react';
import { getProfile } from '../services/auth.service';

import { useAtomValue } from 'jotai';
import { userAtom } from '../store/atoms';
export const useAuth = () => {

    const user = useAtomValue(userAtom);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!user) {
            setLoading(true);
            getProfile().then(() => {
                setLoading(false);
            }, () => {
                setLoading(false);
            });
        } else if (user) {
            setLoading(false);
        }
    }, [user]);
    return {
        user,
        loading
    };
};
